module.exports = __webpack_public_path__ + "img/logo-sanjose3.88e1c813.png";